import { IBulkRegRequest } from "../typings/interfaces/Requests/BulkRegRequest";
import { IInspectApplicationRequest } from "../typings/interfaces/Requests/InspectApplicationRequest";
import { IPetsRegRequests } from "../typings/interfaces/Requests/PetsRegRequests";
import { ISingleRegRequest } from "../typings/interfaces/Requests/SingleRegRequest";
import { IHolidaysResponse } from "../typings/interfaces/Responses/HolidaysResponse";
import { IResponse } from "../typings/interfaces/Responses/Response";
import { ITaskResponse } from "../typings/interfaces/Responses/TaskResponse";
import { IAnimalTypesModel } from "../typings/models/AnimalTypesModel";
import { ICodeMasterModel } from "../typings/models/CodeMasterModel";
import { IInspectionResponseModel } from "../typings/models/InspectionResponseModel";
import { IHarvestApplicationResponseModel } from "../typings/models/HarvestApplicationResponseModel";
import { IOwnerStatus } from "../typings/models/OwnerStatus";
import { IOwnerTransferDetails } from "../typings/models/OwnerTransferDetails";
import { IOwnerTransferInfo } from "../typings/models/OwnerTransferInfo";
import { IPetBreedModel } from "../typings/models/PetBreedModel";
import { IPetColorModel } from "../typings/models/PetColorModel";
import { IPetsDashboardResponseModel } from "../typings/models/PetsDashboardResponseModel";
import { IPetsPendingDashboardResponseModel } from "../typings/models/PetsPendingDashboardResponseModel";
import { API } from "./builder";
import { IHarvestDetailsRegistrationRequest } from "../typings/interfaces/Requests/HarvestDetailsRegistrationRequest";
import { IHarvestDetailsRFAResponseModel } from "../typings/models/HarvestDetailsRFAResponseModel";
import { IHarvestApplicationRFARequest } from "../typings/interfaces/Requests/HarvestApplicationRFARequest";
import { ILicenceIssuedResponseModel } from "../typings/models/LicenceIssuedResponseModel";
import { IVetHealthInspectionRequest } from "../typings/interfaces/Requests/VetHealthInspectionRequest";
import { IMicrochipRegistrationResponseModel } from "../typings/models/MicrochipRegistrationResponseModel";
import { IHarvestDetailsResponseModel } from "../typings/models/HarvestDetailsResponseModel";
import { IPetReportRequests } from "../typings/interfaces/Requests/PetReportRequest";
import { IProductCodeMasterModel } from "../typings/models/ProductCodeMasterModel";
import { ILostAndFoundPetsResponseModel } from "../typings/models/LostAndFoundPetsResponseModel";
import { ILabSampleModelRequest } from "../typings/interfaces/Requests/LabSampleModelRequest";
import { ITestCodeMasterModel } from "../typings/models/TestCodeMasterModel";
import { ISampleNameModel } from "../typings/models/SampleNameModel";
import { ISampleDescriptionModel } from "../typings/models/SampleDescriptionModel";
import { ISampleLocTypeDistrictModel } from "../typings/models/SampleLocTypeDistrictModel";
import { ILabMasters } from "../typings/interfaces/Responses/LabMaster";
import { ILabCountries } from "../typings/models/LabCountries";
import { ICAVSMaster } from "../typings/models/CAVSMaster";
import { ITestPshCavsCodeMasterModel } from "../typings/models/PshCavsTestCodeMasterModel";
import { IBioRequest } from "../typings/interfaces/Requests/BioRequest";
import { IAquaRequest } from "../typings/interfaces/Requests/AquaRequest";
import { IENVRequest } from "../typings/interfaces/Requests/ENVRequest";
import { IAVIRequest } from "../typings/interfaces/Requests/AVIRequest";
import { ITERRequest } from "../typings/interfaces/Requests/TERRequest";
import { IFRWRequest } from "../typings/interfaces/Requests/FRWRequest";
import { ISaveDraftModelRequest } from "../typings/interfaces/Requests/SaveDraftModelRequest";
import { IBIOSaveDraftModelRequest } from "../typings/interfaces/Requests/BIOSaveDraftModelRequest";
import { IPetRegistraionBulkRegRequest } from "../typings/interfaces/Requests/PetRegistrationBulkRequestData";
import { IFileProcessModel } from "../typings/models/FileProcessModel";
import { IAQUASaveDraftModelRequest } from "../typings/interfaces/Requests/AquaSaveDraftModelRequest";
import { IENVSaveDraftModelRequest } from "../typings/interfaces/Requests/ENVSaveDraftModelRequest";
import { ITERSaveDraftModelRequest } from "../typings/interfaces/Requests/TERSaveDraftModelRequest";
import { IAVISaveDraftModelRequest } from "../typings/interfaces/Requests/AVISaveDraftModelRequest";
import { ICalculateFeeResponseModel } from "../typings/interfaces/Requests/CalculateFeeResponseModel";
import {
  IGetAllLabApplication,
  IGetAquaLabApplication,
  IGetBioLabApplication,
  IGetENVLabApplication,
  IGetLabApplication,
  IGetTERLabApplication,
  IGetAVILabApplication,
  IGetAckFile,
  IGetAllAddress,
  IGetInvoices,
  IInvoiceHistoryResponse,
  IInvoiceDownloadResponse,
  IAmendmentHistoryResponse,
} from "../typings/interfaces/Responses/LabApplicationsResponse";
import { ISfaUser } from "../typings/models/SfaUser";
import { IPaymentResponse } from "../typings/interfaces/Payment/PaymentResponse";
import { IPaymentData } from "../typings/interfaces/Payment/PaymentData";
import { IPaymentReceiptData } from "../typings/interfaces/Payment/PaymentReceiptData";
import { IBIOLabSampleModelRequest } from "../typings/interfaces/Requests/BIOSampleModelRequest";
import { IFeeResponse } from "../typings/interfaces/Payment/FeeResponse";
import { IPaymentValidationResponse } from "../typings/interfaces/Payment/PaymentValidationResponse";
import { IPaymentIntentResponse } from "../typings/interfaces/Payment/PaymentIntentResponse";
import { IUenValidationResponse } from "../typings/interfaces/Payment/UenValidationResponse";
import { RatingRequest } from "../typings/interfaces/Requests/Ratingrequest";
import { SpeciesRequest } from "../typings/interfaces/Requests/SpeciesRequest";
import { ILabFeeInput } from "../typings/interfaces/Requests/LabFeeInput";
import { IFaq } from "../typings/models/IFaq";
import { TradeFees } from "../typings/models/TradeFees";
import { IForeignUserModel } from "../typings/models/ForeignUserModel";
import { AxiosResponse } from "axios";
import { PremiseDetailsResponse } from "../typings/interfaces/Requests/PremiseDetailsResponse";
import { ICaptchaRequest } from "../typings/interfaces/Requests/CaptchaRequest";

export interface ISingpassTokenResponse {
  redirectUri: string;
  cacheId: string;
}
//
export const SaveSingleRegistration = (request: ISingleRegRequest) => {
  const url = "/api/registration/captivebredbirdsingleregistration";
  return API.post<IResponse>(url, request);
};

export const SaveBulkRegistration = (request: IBulkRegRequest[]) => {
  const url = "/api/registration/captivebredbirdbulkregistration";
  return API.post<IResponse>(url, request);
};
export const getSPToken = (code: string, state: string) => {
  const url = "/api/authsp/token?authCode=" + code + "&state=" + state;
  return API.post<ISingpassTokenResponse>(url);
};
export const scheduleInspection = (request: IInspectApplicationRequest) => {
  const url = "/api/inspection/scheduleinspection";
  return API.post<ITaskResponse>(url, request);
};
export const getAllTasks = () => {
  const url = "/api/inspection/allscheduleinspectiontasks";
  return API.get<IInspectionResponseModel[]>(url);
};

export const getHolydays = async () => {
  const url = "/api/inspection/holidays";
  return API.get<IHolidaysResponse>(url);
};

export const getTradeFees = async () => {
  const url = "/api/payments/trade-fee";
  return API.get<TradeFees[]>(url);
};

export const savePetsRegistration = (request: IPetsRegRequests) => {
  const url = "/api/registration/petsregistration";
  return API.post<IResponse>(url, request);
};

export const savePetsReportRegistration = (request: IPetReportRequests) => {
  const url = "/api/registration/petreportregistration";
  return API.post<ITaskResponse>(url, request);
};

export const getColours = () => {
  const url = "/api/registration/petcolours";
  return API.get<IPetColorModel[]>(url);
};

export const getAllPetsRegistrations = (userId?: string, email?: string) => {
  const petRegistrationParam = {
    userId,
    email,
  };
  const url = "/api/registration/allpetsregistrations";
  return API.post<IPetsDashboardResponseModel[]>(url, petRegistrationParam);
};

export const getPetBreed = () => {
  const url = "/api/registration/petbreedmasters";
  return API.get<IPetBreedModel[]>(url);
};

export const getAnimalTypes = () => {
  const url = "/api/registration/animaltypes";
  return API.get<IAnimalTypesModel[]>(url);
};

export const saveOwnerTransferInformation = (request: IOwnerTransferInfo) => {
  const url = "/api/registration/ownertransfer";
  return API.post<IResponse>(url, request);
};

export const saveOwnerTransferStatusUpdate = (request: IOwnerTransferInfo) => {
  const url = "/api/registration/ownertransferstatus";
  return API.post<ITaskResponse>(url, request);
};

export const getAllPendingPetsRegistrations = (
  userId?: string,
  email?: string,
  applicationType?: number
) => {
  const url =
    "/api/registration/allpendingpetsregistrations?userId=" +
    userId +
    "&applicationType=" +
    applicationType +
    "&email=" +
    email;
  return API.get<IPetsPendingDashboardResponseModel[]>(url);
};

export const getAllLostAndFoundPets = (userId?: string, email?: string) => {
  const url = `/api/registration/alllostandfoundpets?userId=${userId}&email=${email}`;
  return API.get<ILostAndFoundPetsResponseModel[]>(url);
};

export const ownerChangeToNewOwner = (request: IOwnerStatus) => {
  const url = "/api/registration/ownertransferstatusupdate";
  return API.post<IResponse>(url, request);
};

export const getOriginalOwnerDetailsById = (petsRegistrationId: string) => {
  const url = `/api/registration/originalownerdetailsbyid?param=${petsRegistrationId}`;
  return API.get<IOwnerTransferDetails>(url);
};

export const getHarvestDetails = (userId?: string) => {
  const url = "/api/harvest/harvestdetails?userId=" + userId;
  return API.get<IHarvestApplicationResponseModel[]>(url);
};

export const getHarvestApplications = (userId?: string) => {
  const url = "/api/harvest/harvestapplications?userId=" + userId;
  return API.get<IHarvestApplicationResponseModel[]>(url);
};

export const registerHarvestDetails = (
  request: IHarvestDetailsRegistrationRequest
) => {
  const url = "/api/harvest/registerharvestdetails";
  return API.post<ITaskResponse>(url, request);
};

export const updateHarvestDetails = (
  harvestDetailsAppliationId: string,
  request: IHarvestDetailsRegistrationRequest
) => {
  const url =
    "/api/harvest/updateharvestdetails?harvestDetailsApplicationId=" +
    harvestDetailsAppliationId;
  return API.post<ITaskResponse>(url, request);
};

export const updateExpiryDate = (
  harvestDetailsId: string,
  expiryDate: string | undefined
) => {
  const url =
    "/api/harvest/updateexpirydate?harvestDetailsId=" +
    harvestDetailsId +
    "&expiryDate=" +
    expiryDate;
  return API.post<ITaskResponse>(url);
};

export const getHarvestDetailsRFA = (harvestDetailsAppliationId: string) => {
  const url =
    "/api/harvest/harvestapplicationrfa?harvestApplicationId=" +
    harvestDetailsAppliationId;
  return API.get<IHarvestDetailsRFAResponseModel[]>(url);
};

export const getHarvestDetailsById = (harvestDetailsId: string) => {
  const url =
    "/api/harvest/harvestdetailsbyid?harvestDetailsId=" + harvestDetailsId;
  return API.get<IHarvestApplicationResponseModel[]>(url);
};

export const getHarvestDetailsByPremiseCode = (premiseCode: string) => {
  const url =
    "/api/harvest/harvestdetailsbypremisecode?premiseCode=" + premiseCode;
  return API.get<IHarvestDetailsResponseModel>(url);
};

export const getHarvestDetailsApplicationById = (
  harvestDetailsApplicationId: string
) => {
  const url =
    "/api/harvest/harvestdetailsapplicationbyid?harvestDetailsApplicationId=" +
    harvestDetailsApplicationId;
  return API.get<IHarvestApplicationResponseModel[]>(url);
};

export const saveRFAResponse = (request: IHarvestApplicationRFARequest) => {
  const url = "/api/harvest/saverfaresponse";
  return API.post<ITaskResponse>(url, request);
};

export const checkHarvestAppliactionDetailsByHDId = (
  harvestDetailsId: string
) => {
  const url =
    "/api/harvest/harvestapplicationdetailsbyhdid?harvestDetailsId=" +
    harvestDetailsId;
  return API.get<boolean>(url);
};

export const getSalutations = () => {
  const url = "/api/registration/codemasterlist?codeGroup=Salutation";
  return API.get<ICodeMasterModel[]>(url);
};

export const checkLicenceExistance = (licenceNumber: string) => {
  const url = "/api/harvest/licenceexistance?licenceNumber=" + licenceNumber;
  return API.get<boolean>(url);
};

export const checkPremiseCodeExistance = (premiseCode: string) => {
  const url = "/api/harvest/premiseexistance?premiseCode=" + premiseCode;
  return API.get<boolean>(url);
};

export const getBatchNumbers = (licenceNumber: string) => {
  const url = "/api/harvest/batchnumbers?licenceNumber=" + licenceNumber;
  return API.get<IHarvestDetailsResponseModel>(url);
};

export const getInspections = (type?: string, userId?: string) => {
  const inspectionParam = {
    userId,
    userType: type,
  };
  const url = "/api/inspection/inspections";
  return API.post<IInspectionResponseModel[]>(url, inspectionParam);
};

export const getInspectionById = (inspectionCaseId: string) => {
  const url =
    "/api/inspection/inspectionbyid?inspectionCaseId=" + inspectionCaseId;
  return API.get<IInspectionResponseModel>(url);
};

export const updateInspection = (
  inspectionCaseId: string,
  request: IInspectApplicationRequest
) => {
  const url =
    "/api/inspection/updateinspection?inspectionCaseId=" + inspectionCaseId;
  return API.post<ITaskResponse>(url, request);
};

export const getLicenceDetails = (
  licenceNo: string,
  typeofTransaction: string,
  typeofPermit: string
) => {
  const url =
    "/api/inspection/licencedetailsbylicenceno?licenceNumber=" +
    licenceNo +
    "&typeofTransaction=" +
    typeofTransaction +
    "&typeofPermit=" +
    typeofPermit;
  return API.get<ILicenceIssuedResponseModel>(url);
};

export const saveInspection = (request: IInspectApplicationRequest) => {
  const url = "/api/inspection/updateinspection";
  return API.post<ITaskResponse>(url, request);
};

export const saveVetHealthInspection = (
  inspectionCaseId: string,
  request: IVetHealthInspectionRequest
) => {
  const url =
    "/api/inspection/savevethealthinspection?inspectionCaseId=" +
    inspectionCaseId;
  return API.post<IResponse>(url, request);
};

export const getMicrochipNumbers = () => {
  const url = "/api/harvest/microchipnumbers";
  return API.get<IMicrochipRegistrationResponseModel[]>(url);
};

export const getTradenetPermitDetailsbyPermitNumber = (
  permitNumber: string
) => {
  const url =
    "/api/inspection/tradenetpermitdetailsbypermitnumber?permitNumber=" +
    permitNumber;
  return API.get<boolean>(url);
};

export const getScientificNames = (category: string) => {
  const url = "/api/registration/scientificnames?category=" + category;
  return API.get<IProductCodeMasterModel[]>(url);
};

export const getMicrochipRegistrations = (
  userId?: string,
  registrationType?: number,
  id?: string
) => {
  const url =
    "/api/registration/microchipregistrations?registrationType=" +
    registrationType +
    "&id=" +
    id +
    "&userId=" +
    userId;
  return API.get<IMicrochipRegistrationResponseModel[]>(url);
};

export const updateInspectionStatus = (
  inspectionCaseId: string,
  inspectionStatus: number
) => {
  const url =
    "/api/inspection/updateinspectionstatus?inspectionCaseId=" +
    inspectionCaseId +
    "&inspectionStatus=" +
    inspectionStatus;
  return API.post<ITaskResponse>(url);
};

export const DownloadBulkRegistrationTemplate = (registrationType?: number) => {
  const url =
    "/api/registration/downloadbulktemplate?registrationType=" +
    registrationType;
  return API.get<IResponse>(url);
};

export const SaveBulkRegistrationForPets = (
  request: IPetRegistraionBulkRegRequest
) => {
  const url = "/api/registration/petbulkregistration";
  return API.post<IResponse>(url, request);
};
export const SaveBulkRegistrationForFish = (
  request: IPetRegistraionBulkRegRequest
) => {
  const url = "/api/registration/fishbulkregistration";
  return API.post<IResponse>(url, request);
};
export const getTransferDetailsById = (
  petsRegistrationId: string,
  userId?: string,
  email?: string
) => {
  const url = `/api/registration/transferdetailsbyid?param=${petsRegistrationId}&userId=${userId}&email=${email}`;
  return API.get<IOwnerTransferDetails>(url);
};

export const getFileProcessRecords = (uploadType: string, uen?: string) => {
  const url =
    "/api/registration/fileprocessrecords?uploadType=" +
    uploadType +
    "&uen=" +
    uen;
  return API.get<IFileProcessModel[]>(url);
};

export const getPorts = () => {
  const url = "/api/registration/codemasterlist?codeGroup=35";
  return API.get<ICodeMasterModel[]>(url);
};

export const getPetInfoByMicrochipNo = (
  microchipNo: string,
  ownerId: string,
  ownerIdType: string,
  ownerType?: number,
  email?: string
) => {
  const url = `/api/registration/petinfobymicrochipno?microchipNo=${microchipNo}&ownerType=${ownerType}&ownerId=${ownerId}&ownerIdType=${ownerIdType}&email=${
    email || ""
  }`;
  return API.get<IOwnerTransferDetails>(url);
};

export const createSfaUser = (request: ISfaUser) => {
  const url = "/api/lab/pshsamples";
  return API.post<ITaskResponse>(url, request);
};

// Payments API
export const submitPaymentIntent = (paymentData: IPaymentData) => {
  const url = "/api/payments/create-payment-intent";
  return API.post<IPaymentResponse>(url, paymentData);
};

export const submitPaymentAttachment = (
  paymentReceiptData: IPaymentReceiptData
) => {
  const url = "/api/payments/paymentreceipt?receiptNumber";
  return API.post<IResponse>(url, paymentReceiptData);
};

export const submitPayment = (paymentData: IPaymentData) => {
  const url = "/api/payments/save-payment-detail";
  return API.post<IPaymentResponse>(url, paymentData);
};

export const getFeeByInspectionCaseNumber = (applicationNumber: string) => {
  const url = `/api/payments/inspection-fee?InspectionNumber=${applicationNumber}`;
  return API.get<IFeeResponse>(url);
};

export const getPaymentIntentByID = (paymentIntentId: string) => {
  const url = `/api/payments/get-payment-id?paymentIntentId=${paymentIntentId}`;
  return API.get<IPaymentIntentResponse>(url);
};

export const getPaymentStatus = (applicationNumber: string) => {
  const url = `/api/payments/paymentstatus?referenceNumber=${applicationNumber}`;
  return API.get<IPaymentValidationResponse>(url);
};

export const getPaymentUenStatus = (uen: string) => {
  const url = `/api/payments/validate-uen?uen=${uen}`;
  return API.get<IUenValidationResponse>(url);
};

export const getFCRegNos = () => {
  const url =
    "/api/registration/codemasterlist?codeGroup=FarmCITESRegistrationNumber";
  return API.get<ICodeMasterModel[]>(url);
};

export const updatePetStatus = (petsRegistration: string, status: number) => {
  const url = `/api/registration/updatepetstatus?petsRegistrationId=${petsRegistration}&status=${status}`;
  return API.post<IResponse>(url);
};

// LAB API
export const getBioCountryOfOrigin = () => {
  const url = "/api/registration/codemasterlist?codeGroup=1";
  return API.get<ICodeMasterModel[]>(url);
};
export const getBioCountryOfDestination = () => {
  const url = "/api/registration/codemasterlist?codeGroup=1";
  return API.get<ICodeMasterModel[]>(url);
};
export const getCountries = () => {
  const url = "/api/registration/countries";
  return API.get<ICodeMasterModel[]>(url);
};
export const getLabCountries = () => {
  const url = "/api/lab/countries";
  return API.get<ILabCountries[]>(url);
};
export const getTestCodeMaster = () => {
  const url = "/api/lab/testcodemaster";
  return API.get<ITestCodeMasterModel[]>(url);
};
export const getLabMaster = () => {
  const url = "/api/lab/masters/";
  return API.get<ILabMasters>(url);
};
export const getCAVSMaster = () => {
  const url = "/api/lab/cavsmasters";
  return API.get<ICAVSMaster>(url);
};
export const getSampleTypes = () => {
  const url = "/api/registration/codemasterlist?codeGroup=69";
  return API.get<ICodeMasterModel[]>(url);
};
export const getPSHIndividualTests = (
  selectedSampleType: string,
  selectedSampleDesc: string
) => {
  const url = `/api/lab/individual-test?sampleType=${encodeURIComponent(
    selectedSampleType
  )}&sampleDesc=${encodeURIComponent(selectedSampleDesc)}`;
  return API.get<ITestPshCavsCodeMasterModel>(url);
};

export const getSampleDescriptionbyType = (sampleType: string) => {
  const url = `/api/lab/sampledescriptionbyType?sampleType=${encodeURIComponent(
    sampleType
  )}`;
  return API.get<ISampleDescriptionModel[]>(url);
};
export const getSampleNamesbyType = (sampleType: string) => {
  const url = `/api/lab/samplenamebyType?sampleType=${encodeURIComponent(
    sampleType
  )}`;
  return API.get<ISampleNameModel[]>(url);
};
export const getSampleNames = () => {
  const url = "/api/lab/samplenames";
  return API.get<ISampleNameModel[]>(url);
};
export const getSampleDescriptions = () => {
  const url = "/api/lab/sampledescription";
  return API.get<ISampleDescriptionModel[]>(url);
};

interface IPshCavsTestCodeMasterRequest {
  PurposeCode: string;
  IsBiosurvillanceUser: boolean;
}

export const getPshCavsTestCodeMaster = (
  data: IPshCavsTestCodeMasterRequest
) => {
  const url = `/api/lab/PshCavsMasters`;
  return API.post<ITestPshCavsCodeMasterModel[]>(url, data);
};

export const saveFeedback = (request: RatingRequest) => {
  const url = "/api/lab/customerfeedback";
  return API.post<ITaskResponse>(url, request);
};
export const saveResultRequest = (data: any) => {
  const url = "/api/lab/saveTestDetailResults";
  return API.post<ITaskResponse>(url, data);
};
export const saveAckRequest = (data: any) => {
  const url = "/api/lab/updateTestDetailResults";
  return API.post<ITaskResponse>(url, data);
};
export const getSampleLocTypeDist = () => {
  const url = "/api/lab/sampleloctypedistrict";
  return API.get<ISampleLocTypeDistrictModel[]>(url);
};
export const getAckFile = (applicationNumber?: string) => {
  const url = `/api/lab/applicationattachmentdeails?appNumber=${applicationNumber}`;
  return API.get<IGetAckFile>(url);
};
export const getReportFile = (applicationNumber?: string) => {
  const url = `/api/lab/labReportattachmentdeails?appNumber=${applicationNumber}`;
  return API.get<IGetAckFile>(url);
};
export const labdeclaration = () => {
  const url = "/api/lab/lab-declaration";
  return API.get<ITestPshCavsCodeMasterModel>(url);
};
export const CAVSlabdeclaration = () => {
  const url = "/api/lab/cavs-lab-declaration";
  return API.get<ITestPshCavsCodeMasterModel>(url);
};
export const getBreedSpeciesSpecimensDetails = (purposeCode: string) => {
  const url = `/api/lab/LabBreedSpeciesSpecimenDetails?purposeCode=${purposeCode}`;
  return API.get<SpeciesRequest>(url);
};
export const getBreedSpecimenBySpecies = (speciesName: string) => {
  const url = `/api/lab/BreedSpecimenBySpecies?speciesName=${speciesName}`;
  return API.get<SpeciesRequest>(url);
};
export const getPSHPackages = (packageGroupName: string) => {
  const url = `/api/lab/packages-groups?packageGroupName=${packageGroupName}`;
  return API.get<ITestPshCavsCodeMasterModel>(url);
};
// LabPrepopulate
export const getPSHApplication = (
  applicationNumber: string,
  nric: string,
  isNricRequired: number = 0
) => {
  const url = `/api/lab/prepopulatePSHApplications?appNumber=${applicationNumber}&nric=${nric}&isNricRequired=${isNricRequired}`;
  return API.get<IGetLabApplication>(url);
};

export const getBioApplication = (
  applicationNumber: string,
  nric: string,
  isNricRequired: number = 0
) => {
  const url = `/api/lab/prepopulateBioApplications?appNumber=${applicationNumber}&nric=${nric}&isNricRequired=${isNricRequired}`;
  return API.get<IGetBioLabApplication>(url);
};
export const getENVApplication = (
  applicationNumber: string,
  nric: string,
  isNricRequired: number = 0
) => {
  const url = `/api/lab/prepopulateENVApplications?appNumber=${applicationNumber}&nric=${nric}&isNricRequired=${isNricRequired}`;
  return API.get<IGetENVLabApplication>(url);
};
export const getAquaApplication = (
  applicationNumber: string,
  nric: string,
  isNricRequired: number = 0
) => {
  const url = `/api/lab/prepopulateAQUApplications?appNumber=${applicationNumber}&nric=${nric}&isNricRequired=${isNricRequired}`;
  return API.get<IGetAquaLabApplication>(url);
};
export const getAVIApplication = (
  applicationNumber: string,
  nric: string,
  isNricRequired: number = 0
) => {
  const url = `/api/lab/prepopulateAVIApplications?appNumber=${applicationNumber}&nric=${nric}&isNricRequired=${isNricRequired}`;
  return API.get<IGetAVILabApplication>(url);
};
export const getTERApplication = (
  applicationNumber: string,
  nric: string,
  isNricRequired: number = 0
) => {
  const url = `/api/lab/prepopulateTERApplications?appNumber=${applicationNumber}&nric=${nric}&isNricRequired=${isNricRequired}`;
  return API.get<IGetTERLabApplication>(url);
};
export const getAllLabApplication = (
  nric?: string,
  serviceType?: string | null,
  applicationNumber?: string | null,
  requestFrom?: string | null,
  requestTo?: string | null,
  requestType?: string | null
) => {
  const inspectionParam = {
    nric: nric,
    serviceType: serviceType || null,
    applicationNumber: applicationNumber || null,
    requestFrom: requestFrom || null,
    requestTo: requestTo || null,
    requestType: requestType || null,
  };
  const url = `/api/lab/GetAllLabApplications`;
  return API.post<IGetAllLabApplication[]>(url, inspectionParam);
};

export const getAddress = (
  nric?: string,
  username?: string,
  usertype?: string
) => {
  const inspectionParam = {
    username: usertype === "ForeignerLogin" ? username : nric,
  };
  const url = `/api/usersession/getuseraccountaddress`;
  return API.post<IGetAllAddress[]>(url, inspectionParam);
};

export const getAllThirdPartyLabApplication = (nric?: string) => {
  const url = `/api/lab/GetAllThirdPartyLabApplications?NRIC=${nric}`;
  return API.get<IGetAllLabApplication[]>(url);
};

export const getAllPaymentHistory = (
  nric?: string,
  referenceNumber?: string | null,
  transactionNumber?: string | null,
  requestFrom?: string | null,
  requestTo?: string | null
) => {
  const inspectionParam = {
    nric: nric,
    referenceNumber: referenceNumber || null,
    transactionNumber: transactionNumber || null,
    requestFrom: requestFrom || null,
    requestTo: requestTo || null,
  };
  const url = `/api/payments/paymenthistory`;
  return API.post<IGetAllLabApplication[]>(url, inspectionParam);
};
// Draft
export const SavePSHDraftApplications = (
  request: ISaveDraftModelRequest | ILabSampleModelRequest
) => {
  const url = "/api/lab/savePSHDraftApplications";
  return API.post<ITaskResponse>(url, request);
};
export const SaveBIODraftApplications = (
  request: IBioRequest | IBIOSaveDraftModelRequest
) => {
  const url = "/api/lab/draftbioapplication";
  return API.post<ITaskResponse>(url, request);
};
export const SavAquaDraftApplications = (
  request: IAquaRequest | IAQUASaveDraftModelRequest
) => {
  const url = "/api/lab/draftaquapplication";
  return API.post<ITaskResponse>(url, request);
};
export const SaveTERDraftApplications = (
  request: ITERRequest | ITERSaveDraftModelRequest
) => {
  const url = "/api/lab/draftterapplication";
  return API.post<ITaskResponse>(url, request);
};
export const SaveENVDraftApplications = (
  request: IENVRequest | IENVSaveDraftModelRequest
) => {
  const url = "/api/lab/draftenvapplication";
  return API.post<ITaskResponse>(url, request);
};
export const SaveAVIDraftApplications = (
  request: IAVIRequest | IAVISaveDraftModelRequest
) => {
  const url = "/api/lab/draftaviapplication";
  return API.post<ITaskResponse>(url, request);
};
export const GetDraftApplications = (
  nric?: string,
  serviceType?: string | null,
  applicationNumber?: string | null,
  requestFrom?: string | null,
  requestTo?: string | null
) => {
  const inspectionParam = {
    nric: nric,
    serviceType: serviceType || null,
    applicationNumber: applicationNumber || null,
    requestFrom: requestFrom || null,
    requestTo: requestTo || null,
  };
  const url = `/api/lab/GetDraftApplications?nric=${nric}`;
  return API.post<IGetAllLabApplication[]>(url, inspectionParam);
};

export const DeleteDraftApplications = (ID?: string) => {
  const url = `/api/lab/deleteDraftApplication?ID=${ID}`;
  return API.delete(url);
};
// Submit
export const saveLabApplications = (request: ILabSampleModelRequest) => {
  const url = "/api/lab/pshsamples";
  return API.post<ITaskResponse>(url, request);
};
export const saveBioApplications = (request: IBioRequest) => {
  const url = "/api/lab/biosamples";
  return API.post<ITaskResponse>(url, request);
};
export const saveENVApplications = (request: IENVRequest) => {
  const url = "/api/lab/envsamples";
  return API.post<ITaskResponse>(url, request);
};
export const saveAquaApplications = (request: IAquaRequest) => {
  const url = "/api/lab/aquasamples";
  return API.post<ITaskResponse>(url, request);
};
export const saveTERApplications = (request: ITERRequest) => {
  const url = "/api/lab/tersamples";
  return API.post<ITaskResponse>(url, request);
};
export const saveAVIApplications = (request: IAVIRequest) => {
  const url = "/api/lab/avisamples";
  return API.post<ITaskResponse>(url, request);
};

export const saveFRWApplications = (request: IFRWRequest) => {
  const url = "/api/lab/frwsamples";
  return API.post<ITaskResponse>(url, request);
};

// ammend
export const saveLabAmendment = (request: ILabSampleModelRequest) => {
  const url = "/api/lab/savePSHAmendApplications";
  return API.post<ITaskResponse>(url, request);
};
export const saveBioAmendApplications = (request: IBioRequest) => {
  const url = "/api/lab/amendbioapplication";
  return API.post<ITaskResponse>(url, request);
};
export const saveENVAmendApplications = (request: IENVRequest) => {
  const url = "/api/lab/amendenvapplication";
  return API.post<ITaskResponse>(url, request);
};
export const saveAquaAmendApplications = (request: IAquaRequest) => {
  const url = "/api/lab/amendaquapplication";
  return API.post<ITaskResponse>(url, request);
};
export const saveTERAmendApplications = (request: ITERRequest) => {
  const url = "/api/lab/amendterapplication";
  return API.post<ITaskResponse>(url, request);
};

export const saveAVILabAmendment = (request: IAVIRequest) => {
  const url = "/api/lab/amendaviapplication";
  return API.post<ITaskResponse>(url, request);
};
export const saveFRWLabAmendment = (request: IFRWRequest) => {
  const url = "/api/lab/amendfrwapplication";
  return API.post<ITaskResponse>(url, request);
};
// cancellation

export const saveLabCancellation = (request: ILabSampleModelRequest) => {
  const url = "/api/lab/savePSHCancelApplications";
  return API.post<ITaskResponse>(url, request);
};
export const saveBIOLabCancellation = (request: IBIOLabSampleModelRequest) => {
  const url = "/api/lab/saveBIOCancelApplications";
  return API.post<ITaskResponse>(url, request);
};

export const saveAquaCancellation = (request: IAquaRequest) => {
  const url = "/api/lab/saveAQUcancelApplications";
  return API.post<ITaskResponse>(url, request);
};
export const saveENVCancellation = (request: IENVRequest) => {
  const url = "/api/lab/saveENVcancelApplications";
  return API.post<ITaskResponse>(url, request);
};
export const saveAVICancellation = (request: IAVIRequest) => {
  const url = "/api/lab/saveAVIcancelApplications";
  return API.post<ITaskResponse>(url, request);
};
export const saveTERCancellation = (request: ITERRequest) => {
  const url = "/api/lab/saveTERcancelApplications";
  return API.post<ITaskResponse>(url, request);
};
export const savehardCopyDetails = (data: any) => {
  const url = "/api/lab/SaveHardCopyApplication";
  return API.post<ITaskResponse>(url, data);
};

export const PremiseCodeDetails = async (
  farmCode: string
): Promise<AxiosResponse<PremiseDetailsResponse>> => {
  const url = "/api/lab/premisedetail?premiseCode=" + farmCode;
  return API.get<any>(url);
};
export const labCalculateFee = (request: ILabFeeInput) => {
  const url = "/api/lab/labcalculatefee";
  return API.post<ICalculateFeeResponseModel>(url, request);
};
export const UpdateForeignerUser = (request: IForeignUserModel) => {
  const url = "/api/user/updateforeigneruser";
  return API.post<IForeignUserModel>(url, request);
};
export const getfaqs = () => {
  const url = "/api/lab/lab-faqs";
  return API.get<IFaq[]>(url);
};
export const getMaintainance = async () => {
  const response = await API.get("/api/user/maintenance-message");
    return response.data;
};
export const postValidateRecaptcha = (request: ICaptchaRequest) => {
  const url = "/api/captcha/validatecaptcha";
  return API.post<ITaskResponse>(url, request);
};

export const getInvoiceHistory = (
  requestFrom?: string | null,
  requestTo?: string | null
) => {
  const invoiceParam = {
    requestFrom: requestFrom || null,
    requestTo: requestTo || null,
  };
  const url = `/api/payments/invoicehistory`;
  return API.post<IInvoiceHistoryResponse>(url, invoiceParam);
};

export const downloadInvoice = (invoiceid?: string | null, fileName?: string | null) => {
  const invoicefileParam = {
    invoiceId: invoiceid || null,
    fileName: fileName || null,
  };
  const url = `/api/payments/downloadinvoice`;
  return API.post<IInvoiceDownloadResponse>(url, invoicefileParam);
};

export const downloadInvoiceHistory = (
  requestFrom?: string | null,
  requestTo?: string | null
) => {
  const invoiceParam = {
    requestFrom: requestFrom || null,
    requestTo: requestTo || null,
  };
  const url = `/api/payments/downloadinvoicehistory`;
  return API.post<IInvoiceHistoryResponse>(url, invoiceParam);
};

export const downloadInvoices = (request: IGetInvoices[]) => {
  const response = API.post(
      '/api/payments/downloadinvoices',
      request,
      {
        responseType: 'blob', // VERY IMPORTANT for file download
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return response;
};

export const getAmendmentHistory = async (
  labApplicationNo?: string | null
): Promise<IAmendmentHistoryResponse[]> => {
  const url = `/api/lab/getamendmenthistory`;
  const response = await API.post<IAmendmentHistoryResponse | IAmendmentHistoryResponse[]>(url, labApplicationNo);

  if (!Array.isArray(response.data)) {
    return [response.data];
  }

  return response.data;
};
